<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader showDate>
            <!-- <div class="show_date">
                <ShowYear />
                <ShowMonth style="margin-left: 57px" />
            </div> -->
            <!-- <div class="small_logo">
                <img src="@/assets/img/customer-week-report/cmj.png" alt="" />
            </div> -->
        </ReportHeader>
        <BgContainer>
            <main>
                <div class="title_row">
                    <!-- <PageTitleHome title="新闻版块" /> -->
                    <el-select class="choose_week" placeholder="全部" clearable v-model="week" @change="changeWeek">
                        <el-option v-for="item in weekDict" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="list">
                    <div class="li" v-for="item in modularList" :key="item.tagId">
                        <div class="content" :style="{ backgroundImage: `url(${item.img})` }" @click="toPlate(item)">
                            <h1>{{ item.tagName }}</h1>
                            <h2>{{ item.tagAlias }}</h2>
                            <h3 v-html="item.description"></h3>
                            <div class="btn">了解详情</div>
                        </div>
                        <div class="keyword_list">
                            <div class="keyword" v-for="art in item.articleList" :key="art.articleId" @click="toDetails({ ...art, tagId: item.tagId })">{{ art.articleTitle }}</div>
                        </div>
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
</template>

<script>
export default {
    name: "Home",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { apiFreeWeeklyModular, apiFreeWeeklyList } from "@/request/api";
import { ElMessage } from "element-plus";
import useKeepAlive from "@/store/useKeepAlive";
import useShareLog from "@/utils/useShareLog";
import useWeek from "./useWeek";
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitleHome from "@/components/customer-week-report/pc/PageTitleHome.vue";
import { cloneDeep } from "loadsh";
import { groupBy } from "@/utils";
import { getMmDd } from "@/utils/date";
import HomeHeader from "@/components/common/HomeHeader.vue";

const $router = useRouter();
const $route = useRoute();
const keepAliveStore = useKeepAlive(); // 缓存
const modularList = ref([]); // 版块列表
// 是否是分享
const isShare = computed(() => {
    return !!route.query.share;
});

// 获取版块列表
async function setModularList() {
    const { data } = await apiFreeWeeklyModular({ ...timeRank.value });
    modularList.value = data || [];
}

// 跳转板块
function toPlate(e) {
    const query = { ...$route.query, tagId1: e.tagId };
    if (e.children?.length) {
        query["tagId2"] = e.children[0].tagId;
    }
    $router.push({ path: `/plate`, query });
}

// 跳转文章
function toDetails(e) {
    if (!e.articleId) {
        ElMessage.error("文章不存在");
        return;
    }
    const query = { ...$route.query, articleId: e.articleId, tagId1: e.tagId };
    $router.push({ path: `/details`, query });
}

// 周相关
const { weekDict, week, timeRank, changeWeek } = useWeek({ setModularList });

// 离开页面时如果时跳转详情页，缓存当前页面，如果不是跳转详情页，不缓存当前页面
onBeforeRouteLeave((to, _from, next) => {
    if (to.name === "Details") {
        keepAliveStore.setKeepRoutes(["Home"]);
    } else {
        keepAliveStore.setKeepRoutes([]);
    }
    next();
});

// 记录分享浏览日志
useShareLog();
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: 100vh;
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        .list {
            display: grid;
            grid-template-columns: repeat(2, auto);
            row-gap: 32px;
            justify-content: space-between;
            padding: 40px 0;

            .li {
                width: 413px;
                border-bottom: 1px solid #cdcdcd;
                position: relative;
                cursor: pointer;

                &::after {
                    display: block;
                    content: "";
                    width: 100%;
                    height: 1px;
                    background-color: #fff;
                    position: absolute;
                    left: 0;
                    bottom: -2px;
                }

                .content {
                    width: inherit;
                    height: 171px;
                    background-color: #fff;
                    box-shadow: -1.6px 7.8px 8.19px 0.81px rgba(0, 0, 0, 0.21);
                    // background-image: url(~@/assets/img/时政.jpg);
                    background-position: right bottom;
                    background-repeat: no-repeat;
                    background-size: auto 100%;
                    position: relative;
                    padding: 0 16px;
                    padding-top: 24px;

                    h1 {
                        font-size: 29px;
                        line-height: 1em;
                        text-shadow: 0 0 10px #fff;
                    }

                    h2 {
                        font-size: 16px;
                        line-height: 1em;
                        margin-top: 8px;
                        color: var(--week-primary-color);
                        font-weight: bold;
                    }

                    h3 {
                        max-width: 55%;
                        font-size: 14px;
                        line-height: 1.2em;
                        margin-top: 8px;
                        color: #2f2e2e;
                        font-weight: bold;
                        text-shadow: 0 0 10px #fff;
                    }

                    .btn {
                        line-height: 28px;
                        width: 100px;
                        text-align: center;
                        border-radius: 14px;
                        background-color: var(--week-primary-color);
                        color: #fff;
                        font-size: 14px;
                        font-weight: bold;
                        cursor: pointer;
                        position: absolute;
                        left: 16px;
                        bottom: 14px;
                    }
                }

                .keyword_list {
                    padding-top: 32px;
                    padding-bottom: 21px;

                    .keyword {
                        position: relative;
                        padding-left: 30px;
                        line-height: 1.2em;
                        font-size: 14px;
                        color: #727272;
                        margin-bottom: 12px;
                        cursor: pointer;

                        &:hover {
                            color: var(--week-primary-color);
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }

                        &::before {
                            display: block;
                            content: "";
                            width: 7px;
                            height: 7px;
                            background-color: var(--week-primary-color);
                            position: absolute;
                            left: 0;
                            top: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.choose_week {
    width: 220px;

    .el-input__inner {
        border-color: #b7b7b7 !important;
        border-radius: 0;
        background: none;

        &:focus {
            border-color: #b7b7b7 !important;
        }
    }

    .el-input__suffix {
        background-color: var(--week-primary-color);
        right: 0;
        width: 32px;

        .el-input__suffix-inner {
            width: 100%;

            .el-input__icon {
                width: 100%;
                color: #fff;
            }
        }
    }
}
</style>
